<p-dialog [(visible)]="visivel" [style]="{width: '450px'}" header="Nova posição" [modal]="true" styleClass="p-fluid" (onHide)="escondeDialog()">
    
    <ng-template pTemplate="content">

        <div class="field">
            <label for="posicao">Posição:</label>
            <input id="posicao" pInputText type="text" [(ngModel)]="posicao.cdPosicao" required autofocus>
            <small class="p-error" *ngIf="posicaoEnviada && !posicao.cdPosicao">Posição é obrigatória.</small>
        </div>
        <div class="field">
            <label for="descricao">Descrição:</label>
            <input id="descricao" pInputText type="text" [(ngModel)]="posicao.dePosicao" required autofocus>
            <small class="p-error" *ngIf="posicaoEnviada && !posicao.dePosicao">Descrição é obrigatória.</small>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="escondeDialog()"></button>
        <button pButton label="Salvar" icon="pi pi-check" class="p-button-text" (click)="salvar()"></button>
    </ng-template>

</p-dialog>